import geekboyimg from "./GeekRider-boy.png"
import classes from "./GeekBoy.module.css"
const GeekBoy = props=>{
     return (
        <div className="container-fluid" >
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex justify-content-center align-items-center">
              <span className="p-3 text-white">
               Designed &
                Developed By
                <div className={classes.GeekBoy}>
                  <a href="http://www.geekrider.in/" target="_blank">
                    <span>{"{"}</span>
                    <img src={geekboyimg} alt="geekrider" />
                    <span>{"}"}</span>
                  </a>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    
     )
 }

 export default GeekBoy